import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Snackbar from 'material-ui/Snackbar';
import muiThemeable from 'material-ui/styles/muiThemeable';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import {Title, Body1, Subheading} from './Typography';
import GetInTouchSection from './GetInTouchSection';
import HeroSection from './HeroSection';

import {getQueryVariable} from './history';

import firebase from './firebase';

/* global braintree */

function checkStatus(response) {
  if (response.ok) {
    return response.text();
  } else {
    throw new Error('Network response was not ok.');
  }
}

export default muiThemeable()(class SetupBillingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tosErrorHidden: true,
      tosAndPrivacyChecked: false,
      signupDialogOpen: false,
      snackbarOpen: false,
      snackbarMessage: '',
      isSubmissionDisabled: true,
      user: null,
    };
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({user: user});
        user.getToken().then((token) => {
          this.setState({id_token: token});

          var plans_url = `/api/plans_for_user?user_id=${user.uid}&id_token=${token}`
          var discount_id = getQueryVariable('discount')
          if (discount_id) {
            plans_url += `&discount=${discount_id}`
          }

          fetch(plans_url).then(
            (response) =>
            response.json().then((json) => this.setState({plans: json }))
          );
        });
      } else {
        document.location="/login?next=/setup-billing";
      }
    });

    this.setState({
      isSubmissionDisabled: true
    });

    fetch(`/api/braintree_client_token`, {
        accept: 'application/json',
      }).then(checkStatus)
      .then(this.createBraintreeClient.bind(this))
      .catch(function(error) {
        console.log("failed to get client token");
        console.log(error);
      });
  }

  createBraintreeClient(authorization) {
    this.form = document.querySelector('#checkout-form');

    braintree.client.create({
      authorization: authorization
    }, function (clientErr, clientInstance) {
      if (clientErr) {
        // Handle error in client creation
        return;
      }

      braintree.hostedFields.create({
        client: clientInstance,
        styles: {
          'input': {
            'font-size': '14pt'
          },
          'input.invalid': {
            'color': 'red'
          },
          'input.valid': {
            'color': 'green'
          }
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '4111 1111 1111 1111'
          },
          cvv: {
            selector: '#cvv',
            placeholder: '123'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: '10/2019'
          }
        }
      }, function (hostedFieldsErr, hostedFieldsInstance) {
        if (hostedFieldsErr) {
          // Handle error in Hosted Fields creation
          return;
        }

        this.hostedFieldsInstance = hostedFieldsInstance;

        this.setState({
          isSubmissionDisabled: false
        });

      }.bind(this));
    }.bind(this));
  }

  submitPayment() {
    this.hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
      if (tokenizeErr) {
        // Handle error in Hosted Fields tokenization
        return;
      }

      // Put `payload.nonce` into the `payment-method-nonce` input, and then
      // submit the form. Alternatively, you could send the nonce to your server
      // with AJAX.
      document.querySelector('input[name="payment-method-nonce"]').value = payload.nonce;
      this.form.submit();
    }.bind(this));
  }

  onSubmit() {
    console.log(this.state);

    if (this.state.tosAndPrivacyChecked === false) {
     this.setState({tosErrorHidden : false});
     console.log("validation failed: tos not checked");
     return;
   } else {
     this.setState({tosErrorHidden : true});
     firebase.database().ref('users').child(this.state.user.uid).child('tos_privacy_accepted').set(true).then(
       // success
       () => this.submitPayment(),
       // failure
       (error) => this.setState({snackbarMessage: "Sorry, something went wrong. Try again?", snackbarOpen: true})
     );
   }
  }

  handleChange = (event) => {
    var newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  }

  onCheck = (event, isInputChecked) => {
    this.setState({tosAndPrivacyChecked: isInputChecked});
  }

  render() {
    return (
      <div>
        <HomeGalleryHeader />
        <div className="SignupPage"
          style={{
            backgroundColor: this.props.muiTheme.palette.canvasColor,
          }}>

          <HeroSection
            header="Join Home Gallery Project" />

          <div
            style={{
              width: '500px',
              maxWidth: '90%',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: "left",
            }}>


            <form id="checkout-form" action="/api/braintree_checkout" method="post">
              <Title marginTop="1em">Account Information</Title>
                <div >
                  Signed in as {this.state.user ? this.state.user.displayName : ''}
                  &nbsp;(<a href="/logout?next=/setup-billing">change</a>).
                </div>
              <div><TextField disabled={true} floatingLabelText="Name" value={this.state.user ? this.state.user.displayName : ""} /></div>
              <div><TextField disabled={true} floatingLabelText="Email" value={this.state.user ? this.state.user.email : ""} /></div>

              <Title marginTop="1em">Plan</Title>
              { this.state.plans && this.state.plans.map((plan) =>
                <div key={plan.id}
                     style={{
                       margin: '1em 0em',
                       width: '300px',
                       textAlign: 'center',
                       boxShadow: "1px 1px 3px #c2c2c2",
                       backgroundColor: "#fafafa",
                     }}>

                  <div style={{textAlign: 'center', padding: '2em'}}>
                    <Title>{plan.title}</Title>
                    <Subheading>{plan.subtitle}</Subheading>
                    <hr style={{
                        borderTop: "1px solid #d9d9d9",
                        margin: "1em auto",
                        width: "50%" }}>
                    </hr>
                    {plan.details.map((detail) =>
                      <Body1 key={detail} style={{margin: "0.25em"}}>{detail}</Body1>
                    )}
                    {plan.discount &&
                      <Body1>{plan.discount.title}</Body1>
                    }
                  </div>
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "#efefef",
                      paddingTop: "16px",
                      paddingBottom: "16px"
                    }}>
                    <Body1>${ plan.discount ? (plan.price-plan.discount.amount) : plan.price }/month</Body1>
                  </div>
                </div>
              )}

              <Title marginTop="1em">Billing Information</Title>
             <div id="error-message"></div>
             <div className="BillingHosted">
               <label htmlFor="card-number">Card Number</label>
               <div className="hosted-field" id="card-number"></div>

               <label htmlFor="cvv">CVV</label>
               <div className="hosted-field" id="cvv"></div>

               <label htmlFor="expiration-date">Expiration Date</label>
               <div className="hosted-field" id="expiration-date"></div>

               <input type="hidden" name="payment-method-nonce" />
               {this.state.user && <input type="hidden" name="user_id" value={this.state.user.uid} /> }
               {this.state.id_token && <input type="hidden" name="id_token" value={this.state.id_token} /> }
               {this.state.user && <input type="hidden" name="user_email" value={this.state.user.email} /> }
               {this.state.plans && <input type="hidden" name="plan_id" value={this.state.plans[0].id} /> }
               {this.state.plans && this.state.plans.discount && <input type="hidden" name="discount_id" value={this.state.plans[0].discount.id} /> }
             </div>
             <Body1>
               <br />
             Please review our <a target="_blank" href="/privacy-and-terms#terms-of-service">Terms of Service</a> and <a target="_blank" href="/privacy-and-terms#privacy-policy">Privacy Policy</a>.<br />
             </Body1>
             <Checkbox onCheck={this.onCheck} label="I agree to the Terms of Service and Privacy Policy." />
             <p hidden={this.state.tosErrorHidden} style={{color: "#f44336"}}>Please check the box above to accept the Terms of Service and Privacy Policy.</p>
            </form>
            <RaisedButton primary={true}
              style={{marginTop: '1em', color: this.props.muiTheme.palette.alternateTextColor}}
              disabled={this.state.isSubmissionDisabled}
              onClick={this.onSubmit.bind(this)}>
              Subscribe
            </RaisedButton>
          </div>

          <GetInTouchSection />

          <Snackbar
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            autoHideDuration={10000}
            onRequestClose={() => this.setState({snackbarOpen: false})}
          />

        </div>
        <HomeGalleryFooter />
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/SetupBillingPage.js